import { AccountTypeEnum } from './AccountTypeEnum';
import Administrator from './Administrator';
import Company from './Company';
import Permissions from './Permissions';
import { PermissionsEnum } from './PermissionsEnum';
import { ProviderData } from './ProviderData';
import { AdministratorLicense } from './administrator-license';
import { AdministratorLicenseAvailabilityInfo } from './administrator-license-availability-info';

export default class AdministratorInCamelCase {
  // TODO: delete this class after route api/auth/me will changed data format to camel case
  public id: string;
  public email?: string = null;
  public password?: string;
  public firstName?: string = null;
  public lastName?: string = null;
  public license?: AdministratorLicense = null;
  public permissions?: PermissionsEnum[] = [];
  public companies?: Company[];
  public dateCreated?: number = null;
  public lastLogin?: number = null;
  public enabled? = true;
  public sendInstruction? = true;
  public enabled2FA? = false;
  public isProvider? = false;
  public isSuperAdmin? = false;
  public isReadOnly? = false;
  public isWizardComplete? = true;
  public accountType?: AccountTypeEnum = null;
  public providerInfo?: ProviderData;
  public resellerInfo? = null;
  public adminTrialLicenses?: { [key: number]: AdministratorLicenseAvailabilityInfo };
  public ssoOnly?: boolean;
  public company?: string;

  static modelName = 'AdministratorInCamelCase';

  static canManageAllCompanies(admin: AdministratorInCamelCase): boolean {
    return admin.permissions?.includes(PermissionsEnum.AccessToAllCompanies);
  }
}

export function permissionsListToObject(array: PermissionsEnum[]): Permissions {
  const permissionsSet = new Set(array);
  return Object.values(PermissionsEnum).reduce((acc, value) => {
    acc[value] = permissionsSet.has(value);
    return acc;
  }, {});
}

export function permissionsObjectToList(permissions: Permissions): PermissionsEnum[] {
  return Object.keys(permissions).reduce((acc, item) => {
    if (permissions[item]) {
      acc.push(item);
    }
    return acc;
  }, []);
}
export function convertAdministratorToAdministratorInCamelCase(administrator?: Administrator): AdministratorInCamelCase {
  const data = new AdministratorInCamelCase();
  data.id = administrator.Id;
  data.email = administrator.Email;
  data.password = administrator.Password;
  data.firstName = administrator.FirstName;
  data.lastName = administrator.LastName;
  data.permissions = permissionsObjectToList(administrator.Permissions);
  data.companies = administrator.Companies;
  data.dateCreated = administrator.DateCreated;
  data.lastLogin = administrator.LastLogin;
  data.enabled = administrator.Enabled;
  data.sendInstruction = administrator.SendInstruction;
  data.enabled2FA = administrator.Enabled2FA;
  data.isProvider = administrator.IsProvider;
  data.isSuperAdmin = administrator.IsSuperAdmin;
  data.isReadOnly = administrator.IsReadOnly;
  data.accountType = administrator.AccountType;
  data.resellerInfo = administrator.ResellerInfo;
  return data;
}
